import paged from './paged';

import { socket, getSocketConnectionData } from '@speechki-frontend/core/socket/';
import { getToken } from '@speechki-frontend/core/auth/utils';

export const createPagedBookpartsStore = store => {
    //  [x] register module
    //  [x] set vsEvent
    //  [?] return destroy callback

    store.registerModule('pagedBookparts', paged);

    function handleMessage({ code, params = {} }) {
        if (params.action === 'generate' && code === 200) {
            const ids = params.extra_data.bp_ids;

            ids.forEach(id => {
                store.dispatch('pagedBookparts/updateWithRefetch', {
                    book: params.book_id,
                    id
                });
            });
        }
    }

    const client = socket(getSocketConnectionData(getToken()));
    client.receiver.on('record_process_book_part_update', handleMessage);

    // TODO return destroy callback
};
